import { createFileRoute } from '@tanstack/react-router'

import { AiDeclineImpactScreen } from './-components/ai-decline-impact-screen.tsx'

export const Route = createFileRoute('/reports/ai-decline-impact')({
  component: AiDeclineImpactScreen
})
